import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53e4bbea"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "M-Auto DialogContainer" }
const _hoisted_3 = { class: "DialogBody" }
const _hoisted_4 = { class: "DialogSection F1_75em F-Bold" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_6 = { class: "DialogSection" }
const _hoisted_7 = { class: "DialogSectionTitle" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_9 = { class: "DialogSection" }
const _hoisted_10 = { class: "DialogSectionTitle" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_12 = { class: "DialogSection" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_15 = {
  class: "DialogSection FlexCenter",
  style: {"gap":"1em"}
}
const _hoisted_16 = { class: "F-Bold color3" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1))
const _hoisted_18 = { class: "DialogSection FlexColumn" }
const _hoisted_19 = { class: "CookiesDialogFooter" }
const _hoisted_20 = {
  class: "F-Bold",
  style: {"margin":"auto 1em"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogDisabler = _resolveComponent("DialogDisabler")!
  const _component_CookiesDropInputObject = _resolveComponent("CookiesDropInputObject")!
  const _component_CookiesIcon = _resolveComponent("CookiesIcon")!
  const _component_CookiesNumberInput = _resolveComponent("CookiesNumberInput")!
  const _component_CookiesImageInput = _resolveComponent("CookiesImageInput")!
  const _component_CookiesDescriptionBox = _resolveComponent("CookiesDescriptionBox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      id: 'CookiesDialog_' + _ctx.DialogIndex,
      class: "CookiesDialogdBody"
    }, [
      (_ctx.Saving)
        ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 0 }))
        : _createCommentVNode("", true),
      (_ctx.Loading.length > 0)
        ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 1 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", {
              class: _normalizeClass([_ctx.DialogData.Data.Type === 'Pay'? 'BGRed' : 'BGMain', "Rad2 Shadow0"]),
              style: {"padding":"0.3em 2em","max-width":"70vw"}
            }, _toDisplayString(_ctx.Translate(_ctx.DialogData.Data.Type)), 3)
          ]),
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.Translate('Customer')), 1),
            _createVNode(_component_CookiesDropInputObject, {
              RowHeight: '3em',
              Name: _ctx.DialogData.Data.CustomerType === 'v' ? _ctx.Translate('Vendor') : _ctx.Translate('Customer'),
              CookiesInvalidInput: !(_ctx.MEMRead('D_Transaction_Vendor') && _ctx.MEMRead('D_Transaction_Vendor') !== ''),
              ErrorData: _ctx.ErrorsVisibilty && !(_ctx.MEMRead('D_Transaction_Vendor') && _ctx.MEMRead('D_Transaction_Vendor') !== ''),
              Options: _ctx.Vendors,
              Selectors: [['Name'], ['Serial']],
              Res: 'D_Transaction_Vendor'
            }, null, 8, ["Name", "CookiesInvalidInput", "ErrorData", "Options"]),
            _createVNode(_component_CookiesIcon, {
              class: "SQR2em V-Auto Pointer",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.DialogData.Data.CustomerType === 'v' ? _ctx.NewVendor() : _ctx.NewCustomer())),
              Tooltip: 'New',
              ID: 'Add'
            })
          ]),
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.Translate('Date')), 1),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.$store.state.CookiesMemory.D_Finance_Transaction_CustomDate) = $event)),
              type: "date",
              class: "CookiesInput"
            }, null, 512), [
              [_vModelText, _ctx.$store.state.CookiesMemory.D_Finance_Transaction_CustomDate]
            ])
          ]),
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_CookiesNumberInput, {
              MinWidth: '3em',
              class: "F1_5em",
              PreserveMemory: false,
              Name: _ctx.DialogData.Data.Type === 'Pay' ? _ctx.Translate('Value') : _ctx.Translate('Collected Value'),
              Default: 1,
              Min: 0,
              Unit: _ctx.PriceUnit,
              Res: 'D_Transaction_Value'
            }, null, 8, ["Name", "Unit"]),
            _hoisted_13,
            (_ctx.DialogData.Data.Type !== 'Pay')
              ? (_openBlock(), _createBlock(_component_CookiesNumberInput, {
                  key: 0,
                  MinWidth: '3em',
                  PreserveMemory: false,
                  Name: _ctx.Translate('Discounted'),
                  Default: 0,
                  Max: 0,
                  Unit: _ctx.PriceUnit,
                  Res: 'D_Finance_Transaction_Discount'
                }, null, 8, ["Name", "Unit"]))
              : _createCommentVNode("", true)
          ]),
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.Translate('Attachment')), 1),
            _createVNode(_component_CookiesImageInput, {
              Res: 'D_Finance_Transaction_Attachment',
              style: {"width":"3em","height":"3em","margin":"unset"}
            })
          ]),
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_CookiesDescriptionBox, {
              Placeholder: _ctx.Translate('Notes'),
              Res: 'D_Transaction_Description'
            }, null, 8, ["Placeholder"])
          ])
        ])
      ])
    ], 8, _hoisted_1),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("button", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.go(-1))),
          style: {"background":"var(--colorr1)"},
          class: "F-Bold CookiesButton DialogFooterButton"
        }, _toDisplayString(_ctx.Translate('Cancel')), 1),
        _createElementVNode("button", {
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.SaveData && _ctx.SaveData(...args))),
          style: _normalizeStyle('background: ' + _ctx.Theme.UserColors.main),
          class: "F-Bold CookiesButton DialogFooterButton"
        }, _toDisplayString(_ctx.Translate('Save')), 5)
      ])
    ])
  ], 64))
}